import { IonList, IonItem, IonThumbnail, IonLabel, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonRow, IonText, IonTitle, IonToolbar, useIonAlert,useIonRouter,useIonViewDidEnter,useIonViewWillEnter,withIonLifeCycle } from '@ionic/react';
import React, { useEffect, useState} from 'react';
import  {
    BarcodeScanner,

  } from '@capacitor-mlkit/barcode-scanning';

import "./NearHandCraft.css"
import { RouteComponentProps, useHistory} from 'react-router';
import { arrowBack,alarmSharp,linkSharp, medalSharp } from 'ionicons/icons';
import {useTranslation} from 'react-i18next';
import { changeLanguage } from 'i18next';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import { IonAccordion, IonAccordionGroup } from '@ionic/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

interface Activity {
    id: string,
    marca_comercial: string,
    sector_industria_mx: string,
    sector_industria_us: string,
    sector_industria_fr: string,
    sector_industria_ch: string,
    sector_industria_my: string,
    producto_mx: string,
    producto_us: string,
    producto_fr: string,
    producto_ch: string,
    producto_my: string,
    estado: string,
    municipio: string,
    localidad: string,
    pueblo: string,
    contacto: string,
    telefono: string,
    correos: string,
    descripcion_mx: string,
    descripcion_us: string,
    descripcion_fr: string,
    descripcion_ch: string,
    descripcion_my: string,
    latitud: string,
    longitud: string,
    imagen: string
  }

const NearHandCraft: React.FC<RouteComponentProps> = ({match}) => {
    const [t,i18n] = useTranslation("global");
    const [err,setErr] = useState<string>();
    const [present] = useIonAlert();
    const history = useHistory();
    const router = useIonRouter();

    const [activities, setActivities] = useState<Activity[]>([]);

    useEffect(() => {
        fetch('/manos_indigenas_inpi.json')
        .then(response => response.json())
        .then(data => setActivities(data));
    }, []);

    console.log('Language: ',i18n.language);

    const langEnable = i18n.language;
    let mtitle="", mdesc="", mcurrent="", luginteres="", mname4 = "", mhowgochit4 = "";
    let lempresa="",lproducto="",lubicacion="",lcontacto="",ltelefono="",lcorreos="",lpueblo="";
    let empresa="",producto="",descripcion="";

    switch(langEnable){
        case 'es':
            mtitle = 'Asistente de viaje';
            mdesc = 'En este momento Usted se encuentra en la Riviera Maya. En el Estado de Quintanma Roo, México. Quintana Roo es una región única en el mundo, diversa en cuanto a destinos y atractivos turísticos. Ofrece mar azul, playas de arena blanca, selva tropical, zonas arqueológicas, cenotes, ríos subterráneos, islas, lagunas, cultura Maya viva e historia.';
            mcurrent = 'Como su nombre lo indica, la Riviera Maya fue habitada originalmente por el pueblo maya desde el 200 a. C. Si bien las ciudades que florecieron en la zona no se comparaban a Tikal , Calakmul o Chichen Itzá en cuanto a infraestructura, aún seguían teniendo construcciones en la que se emplearon bases matemáticas y alto nivel de precisión, artes e ingeniería, heredadas de la influencia del Petén y la región Puuc.';
            luginteres = "Lugares de interés cerca de donde te encuentras...";
            mname4 ="Artesanías disponibles cerca";
            mhowgochit4 = "Consideradas una parte muy valiosa de la cultura ancestral de México, las artesanías mexicanas se han convertido desde hace muchos años en un reclamo a nivel mundial. Las artesanías típicas de Quintana Roo son reflejo del legado cultural de la civilización maya y de sus tradiciones. Algunas son utilitarias y otras decorativas, pero todas conforman la expresión de una cultura ofrecida bajo la plataforma turística. Las obras de los artesanos quintanarroenses perpetúan sus modelos tradicionales. En su elaboración son empleados materiales propios de cada región. En la zona maya predominan las artesanías fabricadas con bejuco y madera. En la región costera destacan ingeniosas piezas elaboradas con conchas, caracoles y coral negro. El coral negro es utilizado en la fabricación de joyas exclusivas y de alto valor comercial. Los municipios Felipe Carrillo Puerto, José María Morelos y Othon P. Blanco crean productos textiles de algodón teñidos con tintas naturales, hamacas, prendas de vestir, cojines y mantelería. En X Pichil, Kopchen y demás comunidades del centro de Quintana Roo se aprecian piezas artesanales tejidas con fibras vegetales (mayormente bejucos) como bolsas, sombreros, fruteros. En playa del Carmen se pueden encontrar creativas bolsas, pulseras, collares, dijes y aretes de vistosos y modernos diseños, fabricados a base de conchas y caracoles. También en la zona costera, especialmente en Cancún y Cozumel, son elaborados finos artículos de joyería con coral negro. De la región selvática de Quintana Roo son extraídos ciriote, cedro y caoba. Estos tipos de madera son utilizados en el tallado de esculturas de animales. Puedes comprarlas en la Cooperativa de Artesanos de Quintana Roo, en el Mercado Municipal y en diversos establecimientos locales. Consume productos regionales.";
            lempresa="Empresa";
            lproducto="Producto";
            lubicacion="Ubicación";
            lpueblo="Pueblo";
            lcontacto="Contacto";
            ltelefono="Teléfono";
            lcorreos="Correo";
            break;
        case 'en':
            mtitle = 'Travel assistant';
            mdesc = 'Right now you are in the Riviera Maya. In the State of Quintana Roo, Mexico. Quintana Roo is a unique region in the world, diverse in terms of destinations and tourist attractions. It offers blue sea, white sand beaches, rainforest, archaeological sites, cenotes, underground rivers, islands, lagoons, living Mayan culture and history.';
            mcurrent = 'As the name claims, the Riviera Maya was originally inhabited by the Mayan people as early as 200 BC. Although the cities that flourished in the area did not compare to Tikal, Calakmul or Chichen Itzá in terms of infrastructure, they still had constructions in which mathematical bases and a high level of precision, arts and engineering were used, inherited from the influence of the Petén and the Puuc region.';
            luginteres = "Places of interest near you...";
            mname4 ="Handicrafts available nearby";
            mhowgochit4 = "Considered a very valuable part of Mexico's ancestral culture, Mexican handicrafts have become a worldwide attraction for many years. The typical handicrafts of Quintana Roo are a reflection of the cultural legacy of the Mayan civilization and its traditions. Some are utilitarian and others decorative, but all of them make up the expression of a culture offered under the tourist platform. The works of Quintana Roo artisans perpetuate their traditional models. In its preparation, materials specific to each region are used. In the Mayan area, handicrafts made of vines and wood predominate. In the coastal region, ingenious pieces made with shells, snails and black coral stand out. Black coral is used in the manufacture of exclusive jewelry of high commercial value. The municipalities of Felipe Carrillo Puerto, José María Morelos and Othon P. Blanco create cotton textile products dyed with natural inks, hammocks, clothing, cushions and table linen. In X Pichil, Kopchen and other communities in central Quintana Roo, handicrafts woven with vegetable fibers (mostly vines) such as bags, hats, fruit bowls can be seen. In Playa del Carmen you can find creative bags, bracelets, necklaces, charms and earrings in colorful and modern designs, made from shells and shells. Also in the coastal area, especially in Cancun and Cozumel, fine jewelry items with black coral are made. Cyriote, cedar and mahogany are extracted from the jungle region of Quintana Roo. These types of wood are used in the carving of animal sculptures. You can buy them at the Quintana Roo Artisans Cooperative, at the Municipal Market and in various local establishments. Consume regional products.";
            lempresa="Enterprise";
            lproducto="Product";
            lubicacion="Location";
            lpueblo="Village";
            lcontacto="Contact";
            ltelefono="Phone";
            lcorreos="Email";
            break;
        case 'fr':
            mtitle = 'Assistant de voyage';
            mdesc = 'En ce moment, vous êtes sur la Riviera Maya. Dans l’État de Quintana Roo, au Mexique. Quintana Roo est une région unique au monde, diversifiée en termes de destinations et d’attractions touristiques. Il offre une mer bleue, des plages de sable blanc, une forêt tropicale, des sites archéologiques, des cenotes, des rivières souterraines, des îles, des lagunes, une culture et une histoire mayas vivantes.';
            mcurrent = 'Comme son nom l’indique, la Riviera Maya était à l’origine habitée par le peuple maya depuis 200 av. J.-C. Bien que les villes qui ont prospéré dans la région ne se comparent pas à Tikal, Calakmul ou Chichen Itzá en termes d’infrastructures, elles avaient encore des constructions dans lesquelles des bases mathématiques et un haut niveau de précision, d’art et d’ingénierie étaient utilisés, hérités de l’influence du Petén et de la région de Puuc.';
            luginteres = "Lieux d’intérêt près de chez vous...";
            mname4 ="Artisanat disponible à proximité";
            mhowgochit4 = "Considéré comme une partie très précieuse de la culture ancestrale du Mexique, l’artisanat mexicain est devenu une attraction mondiale depuis de nombreuses années. L’artisanat typique de Quintana Roo est le reflet de l’héritage culturel de la civilisation maya et de ses traditions. Certaines sont utilitaires et d’autres décoratives, mais toutes constituent l’expression d’une culture offerte sous la plateforme touristique. Les œuvres des artisans de Quintana Roo perpétuent leurs modèles traditionnels. Dans sa préparation, des matériaux spécifiques à chaque région sont utilisés. Dans la région maya, l’artisanat composé de vignes et de bois prédomine. Dans la région côtière, des pièces ingénieuses faites de coquillages, d’escargots et de corail noir se distinguent. Le corail noir est utilisé dans la fabrication de bijoux exclusifs de haute valeur commerciale. Les municipalités de Felipe Carrillo Puerto, José María Morelos et Othon P. Blanco créent des produits textiles en coton teint avec des encres naturelles, des hamacs, des vêtements, des coussins et du linge de table. À X Pichil, Kopchen et d’autres communautés du centre de Quintana Roo, on peut voir des objets artisanaux tissés avec des fibres végétales (principalement des vignes) tels que des sacs, des chapeaux, des coupes de fruits. À Playa del Carmen, vous pouvez trouver des sacs, des bracelets, des colliers, des breloques et des boucles d’oreilles créatifs dans des designs colorés et modernes, fabriqués à partir de coquillages et de coquillages. Toujours dans la zone côtière, en particulier à Cancun et Cozumel, des bijoux fins avec du corail noir sont fabriqués. Le cyriote, le cèdre et l’acajou sont extraits de la région de la jungle de Quintana Roo. Ces types de bois sont utilisés dans la sculpture de sculptures d’animaux. Vous pouvez les acheter à la coopérative d’artisans de Quintana Roo, au marché municipal et dans divers établissements locaux. Consommez des produits régionaux.";
            lempresa="Entreprise";
            lproducto="Produit";
            lubicacion="Emplacement";
            lpueblo="Village";
            lcontacto="Contact";
            ltelefono="Téléphone";
            lcorreos="Messagerie électronique";
            break;
        case 'zh':
            mtitle = '旅助理';
            mdesc = '今在里维埃拉玛雅。 在墨西哥金塔纳罗奥州。 金塔纳罗奥州者,世界之独无二也,在目与旅游景点异。 供蔚海、白沙、热带雨林、考古遗址、天然井、地下河、岛屿、泻湖、生玛雅文史。';
            mcurrent = '顾名思义,里维埃拉玛雅自公元前 200 以来始居玛雅人。 虽蓬勃发展城邑基础设施不得与蒂卡尔、卡拉克穆尔、奇琴伊察比,然犹有数学之基,高精度艺之功,继佩滕普克之化。';
            luginteres = "近景点...";
            mname4 ="近有手工艺品";
            mhowgochit4 = "墨西哥手工艺品以为墨西哥先文之甚者,累年以为全球性吸引力。 金塔纳罗奥州之典刑手工艺品玛雅文明旧文化遗产。 有实用者,有装饰性者,皆游平台下之文也。 金塔纳罗奥州工续其传统模式。 制备之际,用特定于方材。 其在玛雅,以藤木为手工艺品占主导地位。 沿海贝、蜗、黑珊瑚巧文脱颖而出。 黑珊瑚造高商业价值独家珠。费利佩·卡里略·波多黎各、何塞·玛丽亚·莫雷洛斯、奥通·布兰科市以天然油墨染棉纺织品、吊床、衣服、靠垫桌布。 金塔纳罗奥州中 X Pichil、Kopchen 、社区,可以见植物纤维(藤蔓)织之手工艺品,囊冠果盘。 普拉亚德尔卡曼得贝、色彩缤纷意包、钏、项链、吊饰、耳环。 同在沿海,尤在坎昆科苏梅尔,制黑珊瑚珠。 Cyriote、雪松、桃花心木,取诸金塔纳罗奥州丛林。 其木以雕虫。可于金塔纳罗奥州工合作社、市政市及诸处市之。 消费区域。";
            lempresa="企業";
            lproducto="產品";
            lubicacion="位置";
            lpueblo="村";
            lcontacto="聯繫";
            ltelefono="電話";
            lcorreos="電子郵件";
            break;
        case 'maya':
            mtitle = 'Áantaj náachil';
            mdesc = "Ti' le súutuka' tech Kula'an ti' le Riviera Maya. Ti' le noj u Quintanma Roo, México. Quintana Roo jach jump'éel región chen kaabe', ya'abach en cuanto a destinos yéetel atractivos turísticos. K'u'ubul k'áak'náabo' ch'ooj, playas arena sak, u k'áaxil tropical, zonas arqueológicas, ts'ono'oto'ob, buuts' subterráneos, islas, lagunas, miatsil maaya viva yéetel k'ajláayo'.";
            mcurrent = "Bix u k'aaba' le indica, le Riviera Maya bin habitada originalmente tumen le kaajo' maaya tak le 200 u. kuxtal Wa bien le ciudades florecieron ti' le kúuchila' ma' u comparaban u Tikal, Calakmul wa Chichen Itzá en cuanto a meyaje', láayli' seguían teniendo construcciones ti' le ba'ax ku emplearon bases matemáticas yéetel ka'anal nivel u precisión, Arteso' yéetel ingeniería, heredadas u influencia le Petén yéetel le petenil Puuc.";
            break;
    }
      const navigate = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        router.push('/app/tabs');
    };
      
    
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar className='custom'>
                        <IonButtons slot='start'>
                          <IonButton onClick={(event) => navigate(event)} color='light'>
                              <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle className="nombre-marca">Mexico Profundo</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen={true} className="ion-padding">
                    <div className="content-museo">
                        <div className="title-name">
                            <h1>{mtitle}</h1>
                        </div>
                    </div>
                    <p>
                    {mdesc}
                    </p>
                    <p>
                    {mcurrent}
                    </p>
                    <IonAccordionGroup>
                        <h2>{luginteres}</h2>
                        <IonAccordion value="fourth">
                            <IonItem slot="header" color="light">
                                <IonThumbnail>
                                    <img alt="..." src="https://maestrovirtuale.com/wp-content/uploads/2019/10/Artesania-en-coral-negro-Quintana-Roo.jpg" />
                                </IonThumbnail>
                                <IonLabel class="padleft7px">
                                    <h3>{mname4}</h3>
                                </IonLabel>
                            </IonItem>
                            <div className="ion-padding" slot="content">
                                <p>{mhowgochit4}</p>
                                <Swiper
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    autoplay={{
                                        delay: 4000,
                                        disableOnInteraction: false
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    navigation={true}
                                    modules={[Autoplay, Pagination, Navigation]}
                                >
                                          {activities.map((activity, index) => {

                                            switch(langEnable){
                                                case 'es':
                                                    producto = activity.producto_mx;
                                                    empresa = activity.sector_industria_mx;
                                                    descripcion = activity.descripcion_mx;
                                                    break;
                                                case 'en':
                                                    producto = activity.producto_us;
                                                    empresa = activity.sector_industria_us;
                                                    descripcion = activity.descripcion_us;
                                                    break;
                                                case 'fr':
                                                    producto = activity.producto_fr;
                                                    empresa = activity.sector_industria_fr;
                                                    descripcion = activity.descripcion_fr;
                                                    break;
                                                case 'zh':
                                                    producto = activity.producto_ch;
                                                    empresa = activity.sector_industria_ch;
                                                    descripcion = activity.descripcion_ch;
                                                    break;
                                            }
                                    return(
                                        <SwiperSlide key={index}>
                                        <div className="slide-content-flex">
                                            <img src={activity.imagen} alt={producto} className="slide-image-flex" />
                                            <div className="slide-labels-flex">
                                            <h3>{producto}</h3>
                                            <h4><strong>{lempresa}</strong>:{activity.marca_comercial}, {empresa}</h4>
                                            <h4>{descripcion}</h4>
                                            <p><strong>{lubicacion}</strong>:{activity.localidad}, {activity.municipio}, {activity.estado}</p>
                                            <p><strong>{lpueblo}</strong>:{activity.pueblo}</p>
                                            <p><strong>{lcontacto}</strong>:{activity.contacto}</p>
                                            <p><strong>{ltelefono}</strong>:{activity.telefono}</p>
                                            <p><strong>{lcorreos}</strong>:{activity.correos}</p>
                                            </div>
                                        </div>
                                        </SwiperSlide>           
                                    )})}

                                    </Swiper>
                            </div>
                        </IonAccordion>
                    </IonAccordionGroup>
                                
                </IonContent>


            </IonPage>
        );
    
};

export default withIonLifeCycle(NearHandCraft);